"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateDomain = exports.truncateAddress = void 0;
/*
 * f: truncateAddress
 */

var truncateAddress = address => {
  return "".concat(address === null || address === void 0 ? void 0 : address.substring(0, 4), "...").concat(address === null || address === void 0 ? void 0 : address.substring((address === null || address === void 0 ? void 0 : address.length) - 4));
};

/*
 * f: truncateDomain
 */
exports.truncateAddress = truncateAddress;
var truncateDomain = (domainName, maxCharacterLength) => {
  if ((domainName === null || domainName === void 0 ? void 0 : domainName.length) > maxCharacterLength) {
    var splits = domainName.split('.');
    if ((splits === null || splits === void 0 ? void 0 : splits.length) > 2) {
      return "".concat(splits[0], "...").concat(splits[(splits === null || splits === void 0 ? void 0 : splits.length) - 1]);
    }
    return domainName;
  }
  return domainName;
};
exports.truncateDomain = truncateDomain;
//# sourceMappingURL=addresses.js.map